import type { OnDestroy, OnInit } from '@angular/core';
import { ChangeDetectorRef, Component, ElementRef, inject, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { FeatureFlag } from 'app/common/enums/feature-flag.enum';
import { isNullOrUndefined } from 'is-what';
import type { StatusSummaryMegaResponse } from '../../mega-exchange/services/interfaces/status-summary-mega-response';
import type { UpcomingSettlementsMegaResponse } from '../../mega-exchange/services/interfaces/upcoming-setttlements-mega-response';
import type { VolumeSummaryMegaResponse } from '../../mega-exchange/services/interfaces/volume-summary-mega-response';
import type { VolumeSummaryRequest } from '../../mega-exchange/services/interfaces/volume-summary-request';
import { MegasService } from '../../mega-exchange/services/megas.service';
import type { User } from '../../models/user';
import { StringConstants } from '../../rcr-exchange/constants/string-constants';
import { RecombinationsService } from '../../rcr-exchange/services/recombinations.service';
import type { RCRFeeScheduleResponse } from '../../shared/interfaces/rcrfeescheduleresponse.interface';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';
import { FeeScheduleService } from '../../shared/services/fee-schedule.service';
import { FmLoadingPageService } from '../../shared/services/fm-loading-page.service';
import { UserService } from '../../shared/services/user.service';
import { FeeDisclaimerService } from '../../shared/services/fee-disclaimer.service';

@Component({
  standalone: false,
  selector: 'invd-dashboard-container',
  templateUrl: './dashboard-container.component.html',
  styleUrls: ['./dashboard-container.component.scss'],
})
export class DashboardContainerComponent implements OnInit, OnDestroy {
  public isCMOOnlyEnabled = false;
  public isCEUser = false;
  public isMegaEnabled = false;
  public isRCREnabled = false;
  public isRCRSupportRoleUser = false;
  public showFeeSheduleModelWindow: boolean;
  public showSFFixedMega = true;
  public showMFFixedMega = true;
  public showSFARMMega = true;
  public showMFARMMega = true;
  public displayPagination = false;
  public imageLoaded = false;
  protected upcomingSettlementErrMsg: string;
  private upcomingSettlementErrorRes: any;
  public committedMegasForCollateralCount = 0;
  public hasCreateOrEditMegaAccessFlag: boolean;
  public hasCollateralUploadAccessFlag: boolean;
  public hasListSettledAndCommittedAccessFlag: boolean;
  private volumeSummaryResCurrent: any;
  private volumeSummaryResNext: any;
  public volumeSummaryResDetails: any;
  public statusSummaryRes: any;
  public upcomingSettlementsRes: any;
  public isVolumeSummaryForCurrentMonth = true;
  public isVolumeSummaryForPreviousMonth = false;
  public isVolumeSummaryForNextMonth = false;
  protected upcomingSettlementsMegaList: any;
  public currentMonthYear: string;
  public singleFamilyFixedMega = '';
  public singleFamilyARMMega = '';
  public multiFamilyFixedMega = '';
  public multiFamilyARMMega = '';
  public committedSettledObject: any = new Object();
  public counter = 0;
  public isLeftArrowClicked = false;
  public isRightArrowClicked = false;
  public currentMonthOffset: number;
  public errorMessagePrevMonth: string;
  public firstErrorMsgForNextMonth: string;
  public showButton = false;
  public selectedStatus = '';
  public statusUpcomingMegaSettlement = '';
  public isStatusDropdownOpen = false;
  public upcomingSettlementsMegaListCount: any;
  public isErrorMessageExits = false;
  public downloadXLSXResponse: any;
  public hidefeeMessage = true;
  public featuretoggle: any;
  public poolInfoTemplateClick = true;
  public msgCount = 0;
  public dynamicBannerHeader = '';
  public dynamicBannerText = '';
  public intervalforScroll: any;
  public msgArray = [];
  public LDShowDynamicBanner = false;
  public dynamicBannerCount = true;
  public isFeeScheduleLinkClicked = true;
  public disclaimerMessage = '';
  private marqueeAnimations: Animation[] = [];

  private router = inject(Router);
  private errorHandlerService = inject(ErrorHandlerService);
  private feeDisclaimerService = inject(FeeDisclaimerService);
  private rcrService = inject(RecombinationsService);
  private userService = inject(UserService);
  private megaService = inject(MegasService);
  public fmLoadingPageService = inject(FmLoadingPageService);
  @Optional() private feeScheduleService = inject(FeeScheduleService);
  private cdr = inject(ChangeDetectorRef);
  private el = inject(ElementRef);

  ngOnInit() {
    this.showFeeSheduleModelWindow = false;
    this.hasCreateOrEditMegaAccessFlag = this.userService.hasCreateOrEditMegaAccessFlag;
    this.hasCollateralUploadAccessFlag = this.userService.hasCollateralUploadAccessFlag;
    this.hasListSettledAndCommittedAccessFlag =
      this.userService.hasListSettledAndCommittedAccessFlag;

    this.msgArray = [];
    this.isFeeScheduleLinkClicked = true;
    this.poolInfoTemplateClick = true;
    if (
      this.userService &&
      !isNullOrUndefined(this.userService) &&
      this.userService.isMEGAUser === true
    ) {
      this.featuretoggle = this.userService.toggleFeatures;
      if (
        this.featuretoggle &&
        this.featuretoggle.includes(FeatureFlag.MEGA_HOMEPAGE_DYNAMIC_BANNER)
      ) {
        this.LDShowDynamicBanner = true;
      }
      this.isMegaEnabled = this.userService.isMEGAUser;
      this.hasCreateOrEditMegaAccessFlag = this.userService.hasCreateOrEditMegaAccessFlag;
      this.hasCollateralUploadAccessFlag = this.userService.hasCollateralUploadAccessFlag;
      this.hasListSettledAndCommittedAccessFlag =
        this.userService.hasListSettledAndCommittedAccessFlag;
      if (this.isMegaEnabled && this.hasListSettledAndCommittedAccessFlag) {
        this.getListCommittedMegasInHomePage();
      }
      this.getDynamicBannerMessage();
      this.fmLoadingPageService.stopLoading();
      this.cdr.detectChanges();
    } else if (this.userService && this.userService.isRCRUser === true) {
      this.isRCREnabled = this.userService.isRCRUser;
      this.isRCRSupportRoleUser = this.userService.isRCRSupportUser;
      this.fmLoadingPageService.stopLoading();
      this.cdr.detectChanges();
    } else {
      this.userService.userProfileSubscription$.subscribe({
        next: (_user: User) => {
          this.isMegaEnabled = this.userService.isMEGAUser;
          this.isRCREnabled = this.userService.isRCRUser;
          this.isRCRSupportRoleUser = this.userService.isRCRSupportUser;
          this.isCMOOnlyEnabled = this.userService.isCMOUser;
          this.isCEUser = this.userService.isCEUser;
          this.getDynamicBannerMessage();
          this.hasCreateOrEditMegaAccessFlag = this.userService.hasCreateOrEditMegaAccessFlag;
          this.hasCollateralUploadAccessFlag = this.userService.hasCollateralUploadAccessFlag;
          this.hasListSettledAndCommittedAccessFlag =
            this.userService.hasListSettledAndCommittedAccessFlag;
          this.featuretoggle = this.userService.toggleFeatures;
          if (this.isMegaEnabled && this.hasListSettledAndCommittedAccessFlag) {
            this.getListCommittedMegasInHomePage();
            if (
              this.featuretoggle &&
              this.featuretoggle.includes(FeatureFlag.MEGA_HOMEPAGE_DYNAMIC_BANNER)
            ) {
              this.LDShowDynamicBanner = true;
            }
          }
          if (
            this.isCMOOnlyEnabled &&
            !this.isMegaEnabled &&
            (!this.featuretoggle ||
              !this.featuretoggle.includes(FeatureFlag.REMIC_SHELF_MENU) ||
              !this.featuretoggle.includes(FeatureFlag.REMIC_GROUP_MENU))
          ) {
            this.isRCREnabled = false;
            this.userService.isRCRUser = false;
            this.isRCRSupportRoleUser = false;
            this.userService.isRCRSupportUser = false;
          }
          this.fmLoadingPageService.stopLoading();
          this.cdr.detectChanges();
        },
        error: (_error: any) => {
          this.fmLoadingPageService.stopLoading();
          this.cdr.markForCheck();
        },
      });
    }
  }

  public getDynamicBannerMessage(): void {
    if (this.userService?.dynamicBannerMessage) {
      this.userService.dynamicBannerMessage.forEach((item) => {
        if (
          item.pageComponent &&
          item.pageComponent.trim() &&
          (item.pageComponent.trim().includes('Dashboard') ||
            item.pageComponent.trim().includes('dashboard'))
        ) {
          this.msgArray = item.bannerMessage;
        }
      }, this);
    }

    this.scrollTop();
  }

  public shouldDisplayBanner(): boolean {
    if (!this.userService?.dynamicBannerMessage) {
      return false;
    }

    for (const item of this.userService.dynamicBannerMessage) {
      if (
        item.pageComponent &&
        item.pageComponent.trim() &&
        (item.pageComponent.trim().includes('Dashboard') ||
          item.pageComponent.trim().includes('dashboard'))
      ) {
        if (!item.shutoffTime) {
          return true;
        }

        const now = new Date();
        const shutoffTime = new Date(item.shutoffTime);
        return shutoffTime > now;
      }
    }

    return false;
  }

  public stopScroll(): void {
    clearInterval(this.intervalforScroll);
    this.marqueeAnimations.forEach((a) => a.pause());
  }

  public startScroll(): void {
    if (this.marqueeAnimations.length > 0) {
      this.marqueeAnimations.forEach((a) => a.play());
      this.intervalforScroll = setInterval(() => {
        this.setIntervalLoop();
      }, 4000);
    } else {
      this.scrollTop();
    }
  }

  public scrollTop() {
    this.msgCount = 0;

    if (this.msgArray && this.msgArray.length === 0) {
      this.dynamicBannerCount = false;
    }

    if (this.msgArray && this.msgArray[0]) {
      const messageParts = this.msgArray[0].split('–');
      this.dynamicBannerHeader = this.decodeHtml(messageParts[0] || '');
      this.dynamicBannerText = this.decodeHtml(messageParts[1] || '');
    } else {
      this.dynamicBannerHeader = '';
      this.dynamicBannerText = '';
    }

    this.msgCount = this.msgCount + 1;
    this.intervalforScroll = setInterval(() => {
      this.setIntervalLoop();
    }, 4000);
    this.cdr.markForCheck();
    this.updateMarqueeDurations();
  }

  decodeHtml(html: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }

  public setIntervalLoop(): void {
    if (this.msgArray && this.msgArray[this.msgCount]) {
      const messageParts = this.msgArray[this.msgCount].split('–');
      this.dynamicBannerHeader = this.decodeHtml(messageParts[0] || '');
      this.dynamicBannerText = this.decodeHtml(messageParts[1] || '');
      this.msgCount = this.msgCount + 1;
      if (this.msgCount >= this.msgArray.length) {
        this.msgCount = 0;
      }
      this.cdr.markForCheck();
      this.updateMarqueeDurations();
    }
  }

  private updateMarqueeDurations(): void {
    setTimeout(() => {
      const PIXELS_PER_SECOND = 60;
      const PAUSE_MS = 2000;
      this.marqueeAnimations.forEach((a) => a.cancel());
      this.marqueeAnimations = [];
      const containers = (this.el.nativeElement as HTMLElement).querySelectorAll<HTMLElement>(
        '.flipping-text, .flipping-text-header',
      );
      containers.forEach((container) => {
        const inner = container.querySelector<HTMLElement>('.marquee-inner');
        if (!inner) return;
        const overflow = Math.max(0, inner.scrollWidth - container.clientWidth);
        if (overflow <= 0) return;
        const travelMs = (overflow / PIXELS_PER_SECOND) * 1000;
        const totalMs = PAUSE_MS + travelMs + PAUSE_MS;
        const anim = inner.animate(
          [
            { transform: 'translateX(0)', offset: 0 },
            { transform: 'translateX(0)', offset: PAUSE_MS / totalMs },
            { transform: `translateX(-${overflow}px)`, offset: (PAUSE_MS + travelMs) / totalMs },
            { transform: `translateX(-${overflow}px)`, offset: 1 },
          ],
          { duration: totalMs, iterations: Infinity, easing: 'linear' },
        );
        this.marqueeAnimations.push(anim);
      });
    }, 100);
  }

  public ngOnDestroy() {
    this.fmLoadingPageService.stopLoading();
    clearInterval(this.intervalforScroll);
  }

  private getListCommittedMegasInHomePage(): void {
    this.getStatusSummaryCount();
    this.getMonthlyVolumeSummary();
    this.getUpcomingMegaSettlements();
  }

  getStatusSummaryCount(): void {
    this.fmLoadingPageService.startLoading();
    const statusSummaryObj: any = new Object();
    statusSummaryObj.duration = 2;
    statusSummaryObj.durationType = 'DAY';
    this.megaService.statusSummaryCount(statusSummaryObj).subscribe({
      next: (data) =>
        this.handelStatusSummaryCountMegaServiceSuccess(data as StatusSummaryMegaResponse),
      error: (error) => this.handleAWSDashboardCommittedMegaServiceFail(error),
    });
  }

  private handelStatusSummaryCountMegaServiceSuccess(
    statusCountResponse: StatusSummaryMegaResponse,
  ): void {
    this.fmLoadingPageService.stopLoading();
    this.statusSummaryRes = statusCountResponse && statusCountResponse.status;
    this.committedMegasForCollateralCount = this.statusSummaryRes.count;
    this.cdr.markForCheck();
  }

  public handleAWSDashboardCommittedMegaServiceFail(_error: any): void {
    this.fmLoadingPageService.stopLoading();
  }

  public getMonthlyVolumeSummary(): void {
    this.fmLoadingPageService.startLoading();
    const volumeSummary = {} as VolumeSummaryRequest;
    volumeSummary.currentMonthOffsetStart = -1;
    volumeSummary.currentMonthOffsetEnd = 1;
    this.megaService.monthlyVolumeSummary(volumeSummary).subscribe({
      next: (data) => this.handleMonthlyVolumeSummarySuccess(data as VolumeSummaryMegaResponse),
      error: (error) => this.handleAWSDashboardCommittedMegaServiceFail(error),
    });
  }

  private handleMonthlyVolumeSummarySuccess(volumeSummary: VolumeSummaryMegaResponse) {
    this.fmLoadingPageService.stopLoading();
    this.isVolumeSummaryForCurrentMonth = true;
    this.isVolumeSummaryForNextMonth = false;
    this.isVolumeSummaryForPreviousMonth = false;
    this.volumeSummaryResCurrent = volumeSummary && volumeSummary.monthlyVolumeSummary;
    this.volumeSummaryResCurrent.forEach((item) => {
      this.populateVolumeSummaryForCurrentMonth(item);
    });
    this.cdr.markForCheck();
  }

  private populateVolumeSummaryForCurrentMonth(item) {
    if (item.currentMonthOffset === 0) {
      this.currentMonthYear = item.summaryDate;
      this.volumeSummaryResDetails = item.megaTypeDetail;
      this.volumeSummaryResDetails.forEach((childItem: any) => {
        if (childItem.megaType != null) {
          this.populateMonthlyVolumeSummary(childItem);
        }
      });
      this.isVolumeSummaryForPreviousMonth = false;
      this.isVolumeSummaryForCurrentMonth = true;
      this.isVolumeSummaryForNextMonth = false;
      this.isErrorMessageExits = false;
      this.volumeSummaryResDetails = null;
      if (item.errorMessage !== null) {
        this.isErrorMessageExits = true;
        this.currentMonthOffset = 0;
        this.showButton = true;
        this.firstErrorMsgForNextMonth = item.errorMessage;
      }
    }
  }

  private populateMonthlyVolumeSummary(item) {
    if (item.megaType != null && item.megaType === StringConstants.MEGA_TYPE_SINGLE_FAMILY_FIX) {
      this.singleFamilyFixedMega = 'SFFIXMEGA';
      this.committedSettledObject.sfFIXCommitted = item.volumeInfo.committed;
      this.committedSettledObject.sfFIXSettled = item.volumeInfo.settled;
      this.committedSettledObject.sfFIXTotal = item.volumeInfo.committed + item.volumeInfo.settled;
    } else if (
      item.megaType != null &&
      item.megaType === StringConstants.MEGA_TYPE_SINGLE_FAMILY_ARM
    ) {
      this.singleFamilyARMMega = 'SFARMMEGA';
      this.committedSettledObject.sfARMCommitted = item.volumeInfo.committed;
      this.committedSettledObject.sfARMSettled = item.volumeInfo.settled;
      this.committedSettledObject.sfARMTotal = item.volumeInfo.committed + item.volumeInfo.settled;
    } else if (
      item.megaType != null &&
      item.megaType === StringConstants.MEGA_TYPE_MULTI_FAMILY_FIX
    ) {
      this.multiFamilyFixedMega = 'MFFIXMEGA';
      this.committedSettledObject.mfFIXCommitted = item.volumeInfo.committed;
      this.committedSettledObject.mfFIXSettled = item.volumeInfo.settled;
      this.committedSettledObject.mfFIXTotal = item.volumeInfo.committed + item.volumeInfo.settled;
    } else if (
      item.megaType != null &&
      item.megaType === StringConstants.MEGA_TYPE_MULTI_FAMILY_ARM
    ) {
      this.multiFamilyARMMega = 'MFARMMEGA';
      this.committedSettledObject.mfARMCommitted = item.volumeInfo.committed;
      this.committedSettledObject.mfARMSettled = item.volumeInfo.settled;
      this.committedSettledObject.mfARMTotal = item.volumeInfo.committed + item.volumeInfo.settled;
    }
  }

  getUpcomingMegaSettlements(): void {
    this.fmLoadingPageService.startLoading();
    const upcomingSettledReq: any = new Object();
    upcomingSettledReq.duration = 2;
    upcomingSettledReq.durationType = 'WEEKS';
    this.megaService.upcomingMegaSettlements(upcomingSettledReq).subscribe({
      next: (data) =>
        this.handleUpcomingMegaSettlementsServiceSuccess(data as UpcomingSettlementsMegaResponse),
      error: (error) => this.handleAWSDashboardCommittedMegaServiceFail(error),
    });
  }

  private handleUpcomingMegaSettlementsServiceSuccess(
    upcomingSettlements: UpcomingSettlementsMegaResponse,
  ) {
    this.fmLoadingPageService.stopLoading();
    this.upcomingSettlementsRes =
      upcomingSettlements &&
      upcomingSettlements.upcomingMegas &&
      upcomingSettlements.upcomingMegas.megaList;
    this.upcomingSettlementErrorRes = upcomingSettlements && upcomingSettlements.upcomingMegas;
    this.upcomingSettlementsMegaList = this.upcomingSettlementsRes;
    this.upcomingSettlementsMegaListCount =
      this.upcomingSettlementsMegaList && this.upcomingSettlementsMegaList.length;
    if (this.upcomingSettlementsMegaList === null) {
      this.upcomingSettlementErrMsg = this.upcomingSettlementErrorRes.errorMessage;
    }
    this.cdr.markForCheck();
  }

  getMonthlyVolumeSummaryByIndex(currentIndex: any): void {
    this.volumeSummaryResNext = [...this.volumeSummaryResCurrent];
    this.firstErrorMsgForNextMonth = '';
    if (currentIndex === '1') {
      this.counter++;
      this.volumeSummaryResNext.forEach((item) => {
        if (this.counter === 1 && item.currentMonthOffset === 1) {
          this.extractVolumeSummary(item);
          this.isVolumeSummaryForPreviousMonth = false;
          this.isVolumeSummaryForCurrentMonth = false;
          this.isVolumeSummaryForNextMonth = true;
          this.isRightArrowClicked = true;
          this.isLeftArrowClicked = false;
          this.isErrorMessageExits = false;
          if (item.errorMessage !== null) {
            this.isErrorMessageExits = true;
            this.currentMonthOffset = 1;
            this.showButton = true;
            this.firstErrorMsgForNextMonth = item.errorMessage;
          }
        } else {
          this.showButton = false;
          this.populateVolumeSummaryCurrentMonth();
        }
      });
    } else if (currentIndex === '-1') {
      this.counter--;
      this.volumeSummaryResNext.forEach((item) => {
        if (this.counter === -1 && item.currentMonthOffset === -1) {
          this.extractVolumeSummary(item);
          this.isVolumeSummaryForPreviousMonth = true;
          this.isVolumeSummaryForCurrentMonth = false;
          this.isVolumeSummaryForNextMonth = false;
          this.isRightArrowClicked = false;
          this.isLeftArrowClicked = true;
          this.isErrorMessageExits = false;
          if (item.errorMessage !== null) {
            this.isErrorMessageExits = true;
            this.currentMonthOffset = -1;
            this.errorMessagePrevMonth = item.errorMessage;
          }
        } else {
          this.showButton = false;
          this.populateVolumeSummaryCurrentMonth();
        }
      });
    }
    this.cdr.markForCheck();
  }

  private populateVolumeSummaryCurrentMonth() {
    this.volumeSummaryResNext.forEach((item) => {
      if (this.counter === 0 && item.currentMonthOffset === 0) {
        this.extractVolumeSummary(item);
        this.isVolumeSummaryForPreviousMonth = true;
        this.isVolumeSummaryForCurrentMonth = false;
        this.isVolumeSummaryForNextMonth = false;
        this.isRightArrowClicked = false;
        this.isLeftArrowClicked = false;
        this.firstErrorMsgForNextMonth = '';
        this.isErrorMessageExits = false;
        if (item.errorMessage !== null) {
          this.isErrorMessageExits = true;
          this.currentMonthOffset = 0;
          this.showButton = true;
          this.firstErrorMsgForNextMonth = item.errorMessage;
        }
      }
    });
  }

  private extractVolumeSummary(item) {
    this.committedSettledObject = {};
    this.singleFamilyFixedMega = '';
    this.singleFamilyARMMega = '';
    this.multiFamilyFixedMega = '';
    this.multiFamilyARMMega = '';
    this.currentMonthYear = item.summaryDate;
    this.volumeSummaryResDetails = item.megaTypeDetail;
    if (this.volumeSummaryResDetails.length > 0) {
      this.volumeSummaryResDetails.forEach((childItem: any) => {
        if (childItem.megaType != null) {
          this.populateMonthlyVolumeSummary(childItem);
        }
      });
      this.errorMessagePrevMonth = '';
      this.firstErrorMsgForNextMonth = '';
    }
  }

  public toggleStatusDropdown(): void {
    this.isStatusDropdownOpen = !this.isStatusDropdownOpen;
  }

  public closeStatusDropdown(): void {
    this.isStatusDropdownOpen = false;
  }

  public setSelected(selectedText: string): void {
    this.isStatusDropdownOpen = false;
    if (selectedText.toLocaleLowerCase() === 'all') {
      this.selectedStatus = '';
    } else {
      this.selectedStatus = selectedText;
    }
    this.statusUpcomingMegaSettlement =
      this.selectedStatus.charAt(0).toUpperCase() + this.selectedStatus.slice(1).toLowerCase();
    this.upcomingSettlementsMegaListCountFun(selectedText);
    this.cdr.markForCheck();
  }

  public upcomingSettlementsMegaListCountFun(selectedText: string): any {
    let items: any[];
    let inreviewStatus = '';
    const key = 'status';

    items = this.upcomingSettlementsMegaList;

    selectedText = selectedText.toLowerCase();
    if (selectedText === 'in review') {
      const inreviewSplit = selectedText.split(' ');
      inreviewStatus = inreviewSplit[0].concat(inreviewSplit[1]);
    }
    items = items.filter((it) => {
      if (it[key].toLowerCase() === selectedText) {
        return true;
      } else if (it[key].toLowerCase() === inreviewStatus) {
        return true;
      } else if (
        selectedText === 'due' &&
        (it[key].toLowerCase() === 'due' || it[key].toLowerCase() === 'duewarning')
      ) {
        return true;
      } else if (selectedText === 'all') {
        return true;
      } else if (selectedText === 'allocation_pending') {
        return true;
      } else {
        return false;
      }
    });
    this.upcomingSettlementsMegaListCount = items.length;
  }

  public navigateToLookup() {
    this.router.navigate(['/rcr-exchange/lookup']);
  }

  getFeeSchedule(): void {
    if (this.isFeeScheduleLinkClicked) {
      this.feeScheduleService.getExchangeFeeSchedule().subscribe({
        next: (data) => this.handleRcrFeeResponse(data as RCRFeeScheduleResponse),
        error: (error) => this.handleRcrFeeResponseError(error),
      });
    }

    this.isFeeScheduleLinkClicked = false;
  }

  private handleRcrFeeResponse(rcrFeeResponseObject: RCRFeeScheduleResponse) {
    this.isFeeScheduleLinkClicked = true;
    this.rcrService.setFeeScheduleData(rcrFeeResponseObject);
    this.showFeeSheduleModelWindow = true;
    this.cdr.markForCheck();
  }

  protected closeFeeSheduleModelWindow() {
    this.showFeeSheduleModelWindow = false;
    this.cdr.markForCheck();
  }

  private handleRcrFeeResponseError(error: any) {
    this.isFeeScheduleLinkClicked = true;
    const errorObject = error.error;
    this.errorHandlerService.setErrorObj(errorObject);
    this.router.navigate(['error']);
  }

  protected imageLoad(): void {
    this.imageLoaded = true;
    this.cdr.markForCheck();
  }

  public downloadPoolInfoTemplate(): void {
    this.fmLoadingPageService.startLoading();
    if (this.poolInfoTemplateClick) {
      this.megaService.downloadXLSXPoolInfoTemplate().subscribe({
        next: (data) => this.handleDownloadXLSXServiceSuccess(data),
        error: (error) => this.handleAWSownloadXLSXServiceFail(error),
      });
    }

    this.poolInfoTemplateClick = false;
  }

  public handleDownloadXLSXServiceSuccess(downloadXLSXRes) {
    this.fmLoadingPageService.stopLoading();
    this.downloadXLSXResponse = downloadXLSXRes;
    let data = this.downloadXLSXResponse;
    const fileName = 'Fannie Mae Pool Information Template.xlsx';
    data = data.replace(/^[^,]+,/, '');
    data = data.replace(/\s/g, '');
    const byteCharacters = window.atob(data);
    const byteNumbers = Array.from({ length: byteCharacters.length });
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers as any);
    const blob = new Blob([byteArray], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    if ((window.navigator as any).msSaveOrOpenBlob) {
      (window.navigator as any).msSaveOrOpenBlob(blob, fileName);
    } else {
      const objectUrl: string = URL.createObjectURL(blob);
      const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
      a.href = objectUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    }

    this.poolInfoTemplateClick = true;
    this.cdr.markForCheck();
  }

  public handleAWSownloadXLSXServiceFail(_error: any): void {
    this.fmLoadingPageService.stopLoading();
    this.poolInfoTemplateClick = true;
    this.cdr.markForCheck();
  }

  public closeFeeMessageBanner(): void {
    this.hidefeeMessage = false;
    this.cdr.markForCheck();
  }

  public needsDisclaimer(mega: any): boolean {
    if (this.feeDisclaimerService.needsDisclaimer(mega.prefixCode) && mega.status.includes('DUE')) {
      this.disclaimerMessage = StringConstants.SUPERS_PREFIX_FEE_DISCLAIMER;
      return true;
    }
    return false;
  }

  protected trackByIdentity(_index: number, obj: any) {
    return obj;
  }
}
